/* Sticky mobile ATC bar (Pat) — r3 (2026-05-06):
   iOS Safari ignores :disabled CSS on the sticky CTA. Apply inline styles
   directly when disabled so the gray state actually shows. r2 fix kept the
   flash-blocker on tap. */
/* BS-111 (2026-06-08): the sticky CTA used to mirror only inline.disabled.
   Pipeline's Alpine re-enables button.disabled ~100ms after our JS disable,
   so the sticky bar read "enabled" and let shoppers add a cake with an EMPTY
   required inscription (napis na torcie / napisz swój list / candle digit).
   Now we consult the authoritative empty-field state (requiredFieldBlocked)
   in BOTH the disabled mirror and the click guard, and flash the empty field
   on a blocked tap. Self-contained — no dependency on napis-atc-sync internals. */

(function v60cStickyAtc() {
	var STYLE_ID = 'batida-sticky-atc-css';
	var BAR_ID   = 'batida-sticky-atc';
	var ATC_SEL  = '.btn--add-to-cart';
	var PRICE_SEL = '[data-product-price]';

	function injectStyles() {
		if (document.getElementById(STYLE_ID)) return;
		var s = document.createElement('style');
		s.id = STYLE_ID;
		s.textContent = [
			'.batida-sticky-atc{',
				'position:fixed;left:0;right:0;bottom:0;z-index:100;',
				'background:#fff;border-top:1px solid #e3d5ca;',
				'padding:10px 14px calc(10px + env(safe-area-inset-bottom, 0px));',
				'display:flex;align-items:center;gap:12px;',
				'transform:translateY(100%);',
				'transition:transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);',
				'box-shadow:0 -2px 14px rgba(0, 0, 0, 0.08);',
				'pointer-events:none;',
			'}',
			'.batida-sticky-atc.is-visible{transform:translateY(0);pointer-events:auto;}',
			'.batida-sticky-atc__price{',
				'font-size:15px;font-weight:500;color:#2b2017;',
				'min-width:64px;flex-shrink:0;',
			'}',
			'.batida-sticky-atc__cta{',
				'flex:1;min-width:0;',
				'background:#2b2017;color:#fff;border:none;',
				'padding:13px 18px;',
				'font-size:12px;letter-spacing:0.06em;',
				'text-transform:uppercase;font-weight:500;',
				'border-radius:6px;cursor:pointer;',
				'display:flex;align-items:center;justify-content:center;gap:8px;',
				'transition:background 0.15s, opacity 0.15s, filter 0.15s;',
				'font-family:inherit;',
			'}',
			'.batida-sticky-atc__cta:hover:not(:disabled){background:#3d2f24;}',
			'.batida-sticky-atc__cta__arrow{font-size:14px;line-height:1;}',
			'body.batida-cart-drawer-open .batida-sticky-atc{display:none !important;}',
			'@media (min-width: 768px){.batida-sticky-atc{display:none !important;}}',
			'@media (max-width: 767px){',
				'body.batida-sticky-atc-active{padding-bottom:72px;}',
			'}'
		].join('');
		(document.head || document.documentElement).appendChild(s);
	}

	function findInlineAtc()  { return document.querySelector(ATC_SEL); }
	function findInlinePrice(){ return document.querySelector(PRICE_SEL); }

	/* ---- BS-111: authoritative required-field guards (mirror napis-atc-sync
	   + batida-z-wiadomoscia logic, but self-contained so the sticky bar never
	   relies on the Alpine-clobbered inline.disabled flag) ---- */
	function napisOn() {
		var w = document.querySelectorAll('.selector-wrapper[data-select-label]');
		for (var i = 0; i < w.length; i++) {
			var lbl = (w[i].getAttribute('data-select-label') || '').toLowerCase();
			if (lbl.indexOf('napis') !== -1 || lbl.indexOf('nappis') !== -1 ||
				lbl.indexOf('tabliczka') !== -1 || lbl.indexOf('inscription') !== -1 ||
				lbl.indexOf('inschrift') !== -1 || lbl.indexOf('beschriftung') !== -1 ||
				lbl.indexOf('напис') !== -1) {
				var tak = w[i].querySelector('input[type="radio"][value="TAK" i], input[type="radio"][value="YES" i], input[type="radio"][value="OUI" i], input[type="radio"][value="JA" i], input[type="radio"][value="ТАК" i]');
				return !!(tak && tak.checked);
			}
		}
		return false;
	}
	function crossOn(handle) {
		var cp = document.querySelector('.cross-product[data-canonical-handle="' + handle + '"]') ||
			document.querySelector('.cross-product--' + handle);
		if (!cp) return false;
		var cb = cp.querySelector('.cross-product__checkbox') || cp.querySelector('input[type="checkbox"]');
		return !!(cb && cb.checked);
	}
	function emptyVal(el) { return !el || (el.value || '').trim().length === 0; }
	/* A required add-on field counts only when it's actually shown to the shopper.
	   The personalization card (batida-personalizacja-v2) hides the field's
	   wrapper (hidden attr / display:none) until its toggle is ON, so
	   offsetParent===null means the add-on isn't selected → not required. */
	function activeEmpty(el) { return !!(el && el.offsetParent !== null) && emptyVal(el); }
	/* Clarity 2 (Aleksandra 5.10): since 2.10 "Napis na torcie" is an optional add-on (snippets/batida-personalizacja-v2,
	   [data-napis-addon]): its field is always on screen and empty = no inscription. It must not grey out this bar - the
	   bar stayed disabled on every such cake (Duet, Miłości, ...) until something was typed, while the page's own
	   button worked. Revert: delete this function and its two uses below. */
	/* 5.10 evening: on batida.pl assets/batida-v7-pdp.js moves the field out of the card into the "+ 10,00 zł · opcjonalnie"
	   box (.v7-napis) above it, so closest() on the card alone missed it and the bar stayed grey; that box is optional
	   by design (empty = switch off; a TAK variant with an empty field is still caught by napisOn()). */
	function napisOptional(el) { return !!(el && el.closest && (el.closest('[data-napis-addon]') || el.closest('.v7-napis'))); }
	function requiredFieldBlocked() {
		// "napisz swój list" standalone product (z-wiadomoscia) — robust form flag
		if (document.querySelector('form[data-batida-zw-empty="1"]')) return true;
		// cake inscription — variant radio OR personalization toggle (#batida-napis-text)
		var napisEl = document.getElementById('batida-napis-text');
		if (activeEmpty(napisEl) && !napisOptional(napisEl)) return true;
		// "write your letter" personalization add-on
		if (activeEmpty(document.querySelector('textarea[name="properties[_Message-Wiadomosc]"]'))) return true;
		// candle digit
		if (activeEmpty(document.querySelector('.cross-product__input-text--candles'))) return true;
		// belt-and-braces: variant-radio napis even if visibility is quirky
		if (napisOn() && emptyVal(document.getElementById('batida-napis-text'))) return true;
		// forward-compat: honor napis-atc-sync guard if it ever exposes one
		if (window.batidaNapisGuard && typeof window.batidaNapisGuard.isBlocked === 'function' && window.batidaNapisGuard.isBlocked()) return true;
		return false;
	}
	function isAtcBlocked() {
		var atc = findInlineAtc();
		if (!atc) return true;
		if (atc.disabled) return true;
		return requiredFieldBlocked();
	}
	function flashEl(el) {
		if (!el) return;
		try { el.classList.add('batida-input-error'); } catch (e) {}
		try { el.focus(); } catch (e) {}
		try { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
	}
	function flashBlocked() {
		var n = document.getElementById('batida-napis-text'); if ((activeEmpty(n) && !napisOptional(n)) || (napisOn() && emptyVal(n))) { flashEl(n); return true; }
		var letter = document.querySelector('textarea[name="properties[_Message-Wiadomosc]"]'); if (activeEmpty(letter)) { flashEl(letter); return true; }
		var c = document.querySelector('.cross-product__input-text--candles'); if (activeEmpty(c)) { flashEl(c); return true; }
		var zw = document.querySelector('[data-batida-zw-input]'); if (zw && emptyVal(zw)) { try { zw.classList.add('batida-zw-error'); } catch (e) {} flashEl(zw); return true; }
		return false;
	}

	function readCtaLabel() {
		var atc = findInlineAtc();
		if (!atc) return '';
		var ready = atc.querySelector('.btn-state-ready');
		var clone = (ready || atc).cloneNode(true);
		clone.querySelectorAll('.batida-atc-arrow, [data-button-price]').forEach(function (n) { n.remove(); });
		// 25.09: also drop the "•" that separated the (removed) price, so the bar reads "DODAJ DO KOSZYKA →", not "DODAJ DO KOSZYKA • →"
		return clone.textContent.replace(/\s+/g, ' ').trim().replace(/[\s•·|]+$/, '');
	}

	/* r3: inline-style fallback for iOS Safari that ignores :disabled CSS */
	function applyDisabledInlineStyles(cta) {
		cta.style.setProperty('background', '#c9bcae', 'important');
		cta.style.setProperty('color', '#7a6c5c', 'important');
		cta.style.setProperty('opacity', '0.55', 'important');
		cta.style.setProperty('filter', 'grayscale(0.5)', 'important');
		cta.style.setProperty('cursor', 'not-allowed', 'important');
	}
	function clearDisabledInlineStyles(cta) {
		cta.style.removeProperty('background');
		cta.style.removeProperty('color');
		cta.style.removeProperty('opacity');
		cta.style.removeProperty('filter');
		cta.style.removeProperty('cursor');
	}

	function build() {
		if (document.getElementById(BAR_ID)) return;
		var atc = findInlineAtc();
		if (!atc) return;

		var bar = document.createElement('div');
		bar.id = BAR_ID;
		bar.className = 'batida-sticky-atc';
		bar.setAttribute('aria-hidden', 'true');
		bar.innerHTML =
			'<div class="batida-sticky-atc__price" aria-hidden="true"></div>' +
			'<button type="button" class="batida-sticky-atc__cta">' +
				'<span class="batida-sticky-atc__cta__label"></span>' +
				'<span class="batida-sticky-atc__cta__arrow" aria-hidden="true">→</span>' +
			'</button>';
		document.body.appendChild(bar);
		document.body.classList.add('batida-sticky-atc-active');

		bar.querySelector('.batida-sticky-atc__cta').addEventListener('click', function (e) {
			var inline = findInlineAtc();
			if (!inline || isAtcBlocked()) {
				e.preventDefault();
				e.stopPropagation();
				var handled = flashBlocked() || (window.batidaPerso && typeof window.batidaPerso.flashBlocker === 'function' && window.batidaPerso.flashBlocker());
				if (!handled && inline) {
					try { inline.scrollIntoView({behavior:'smooth', block:'center'}); } catch (e) {}
				}
				return;
			}
			inline.click();
		});
	}

	function syncContent() {
		var bar = document.getElementById(BAR_ID);
		if (!bar) return;
		var price = findInlinePrice();
		var atc = findInlineAtc();
		if (price) {
			var priceText = price.textContent.replace(/\s+/g, ' ').trim();
			var priceEl = bar.querySelector('.batida-sticky-atc__price');
			if (priceEl && priceEl.textContent !== priceText) priceEl.textContent = priceText;
		}
		var cta = bar.querySelector('.batida-sticky-atc__cta');
		var label = bar.querySelector('.batida-sticky-atc__cta__label');
		if (atc && label && cta) {
			var newLabel = readCtaLabel();
			if (newLabel && label.textContent !== newLabel) label.textContent = newLabel;
			var disabled = isAtcBlocked();
			cta.disabled = disabled;
			/* r3: also apply inline styles since iOS ignores :disabled CSS */
			if (disabled) applyDisabledInlineStyles(cta);
			else clearDisabledInlineStyles(cta);
		}
	}

	function syncVisibility() {
		var bar = document.getElementById(BAR_ID);
		if (!bar) return;
		var atc = findInlineAtc();
		if (!atc) {
			bar.classList.remove('is-visible');
			return;
		}
		var rect = atc.getBoundingClientRect();
		var aboveViewport = rect.bottom < 0;
		var belowViewport = rect.top > window.innerHeight;
		var shouldShow = aboveViewport || belowViewport;
		bar.classList.toggle('is-visible', shouldShow);
		bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
	}

	function init() {
		if (!findInlineAtc()) return;
		injectStyles();
		build();
		syncContent();
		syncVisibility();

		window.addEventListener('scroll', syncVisibility, { passive: true });
		window.addEventListener('resize', syncVisibility);

		document.addEventListener('theme:variant:change', syncContent);
		var __syncTimer=null,scheduleSync=function(){clearTimeout(__syncTimer);__syncTimer=setTimeout(syncContent,60);};document.addEventListener('input',scheduleSync,true);document.addEventListener('change',scheduleSync,true);document.addEventListener('click',scheduleSync,true);

		document.addEventListener('theme:cart:change', syncContent);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
